import { Stack, Paper, Grid, SvgIcon, Typography } from "@mui/material";
import TitleHeadSess from "../../utils/TitleHeadSess";
import FormtTemplate from "./FormtTemplate";
import PaperRedirectVid from "./PaperRedirectVid";
import { useForm } from "react-hook-form";
import { useApi } from "../../utils/hooks";

const prescriptionsUrl =
  "https://drive.google.com/file/d/15aPZF0JjT3z_m8a5oP7a00oiqsKW98Qh/view?usp=share_link";
const ordersUrl =
  "https://drive.google.com/file/d/1jt098n8N6gYvU8fgVSZSVuBbv2gtnAc2/view?usp=share_link";

const Templates = () => {
  const api = useApi();
  const defaultValues = {
    type: "order",
    name: "",
    content: "",
    inputMethod: "text",
  };

  const form = useForm({
    defaultValues,
  });

  const type = form.watch("type");

  const createTemplate = ({ type, templateDto }) =>
    api.createTemplate(type, templateDto);

  const videoUrl = type == "prescription" ? prescriptionsUrl : ordersUrl;

  return (
    <Stack
      spacing="1rem"
      sx={{ p: { xs: "1rem", sm: "2rem" }, mt: { xs: "1rem" }, width: "100%" }}
    >
      <TitleHeadSess title={"Nueva Plantilla"} urlRedirect={"/"} />
      <Grid container>
        <Grid
          item
          xs={12}
          sm={12}
          md={6.5}
          xl={8}
          sx={{ pr: { xs: 0, sm: 0, md: 1 } }}
        >
          <Paper
            variant="outlined"
            width="100%"
            sx={{
              p: { xs: "20px 10px", sm: "20px 40px" },
              borderRadius: 3,
              mb: { xs: 4, sm: 7 },
            }}
          >
            <FormtTemplate
              onSubmitOperation={createTemplate}
              form={form}
              type={type}
            />
          </Paper>
        </Grid>

        <Grid
          item
          xs={12}
          sm={12}
          md={5.5}
          xl={4}
          sx={{ pl: { xs: 0, sm: 0, md: 1 } }}
        >
          <PaperRedirectVid videoUrl={videoUrl} />
        </Grid>
      </Grid>
    </Stack>
  );
};

export default Templates;
